import React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import AssignmentIcon from '@mui/icons-material/Assignment';
import Typography from 'component/commonComponents/Typography';
import { ListWrapper } from './TaskList.style';
import { NewJoinerTaskDefinition } from '../types'

export interface TaskListProps {
  tasks?: NewJoinerTaskDefinition[];
  title?: string;
}

const TaskList = (props: TaskListProps) => {
  const { tasks, title } = props;

  return (
    <ListWrapper>
      <Typography kind="h6">{title}</Typography>
      <List>
        {tasks?.map(task => {
          return (
            <ListItem key={task.id}>
              <ListItemIcon>
                <AssignmentIcon />
              </ListItemIcon>
              <ListItemText>{task?.translatingLabel || task?.name}</ListItemText>
            </ListItem>
          )
        })}
      </List>
    </ListWrapper>
  );
};

export default TaskList;
